import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const Container = styled(Box)<{
    $borderRadius: number;
    $paddingBottom: number;
    $paddingTop: number;
    $paddingX: number;
    $backgroundColor: string;
}>`
    ${({ $paddingTop }) => Number.isInteger($paddingTop) && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingBottom }) => Number.isInteger($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
    ${({ $borderRadius }) => Number.isInteger($borderRadius) && `border-radius: ${$borderRadius}px;`};
    ${({ $paddingX }) => Number.isInteger($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
`;

export const StepNumber = styled(Box)<{
    $borderRadius: number;
    $paddingBottom: number;
    $paddingTop: number;
    $paddingX: number;
    $backgroundColor: string;
    $borderColor: string;
}>`
    ${({ $paddingTop }) => Number.isInteger($paddingTop) && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingBottom }) => Number.isInteger($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
    ${({ $borderRadius }) => Number.isInteger($borderRadius) && `border-radius: ${$borderRadius}px;`};
    ${({ $paddingX }) => Number.isInteger($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
    ${({ theme, $borderColor }) => $borderColor && `border: 1px solid  ${theme[$borderColor]};`};
    width: fit-content;
    display: inline-block;
    position: absolute;
    top: -15px;
    left: 0;
    right: 0;
    margin: 0 auto;
`;
